interface DataSourceSchema {
  type: string,
  storeType: string,
  defaultValue: string
  required: boolean
  properties: Map<string, DataSourceSchema>
}
export class DataSource {
  type: string = 'entity'
  relatedDataSource?: string//  数据源名称relatedDataSource 目前后端用 alias
  children: Array<any>
  lazy: boolean = false
  constructor(schema: DataSourceSchema) {
    this.relatedDataSource = schema?.defaultValue
    this.children = this.initChildren(schema?.properties)
  }

  initChildren(properties: any | Map<string, DataSourceSchema>) {
    if (typeof properties === 'object') {
      const propertiesMap = new Map()
      Object.keys(properties).forEach((key: any) => {
        propertiesMap.set(key, properties[key])
      })
      properties = propertiesMap
    }
    const childrens: { alias: string; dataSource: DataSource }[] = []
    properties?.forEach((value: DataSourceSchema, key: string) => {
      childrens.push({ alias: key, dataSource: new DataSource(value) })
    })
    return childrens
  }

  getChildren() {
    return this.children.map((item) => {
      return { alias: item.alias }
    })
  }
}